import { useState, useEffect } from 'react';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

  useEffect(() => {
    if (window) {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }
  }, [window.innerHeight, window.innerWidth]);

  return windowSize;
}

export default useWindowSize;
